<template>
  <v-row>
    <v-col md="8" offset-md="2" xl="6" offset-xl="3">
      <BaseBlock v-if="titreCampus" :title="titreCampus">
        <v-form v-model="valid" ref="form">
          <BaseAlert :error="error" />
          <v-row>
            <v-col cols="12" md="10" offset="0" offset-md="1">
              <v-text-field
                v-model="campus.libelle"
                label="Libellé *"
                dense
                @input="resetApiErrors('libelle')"
                :error-messages="checkApiErrors('libelle')"
                :rules="libelleRules"
              ></v-text-field> </v-col
          ></v-row>
          <v-row>
            <v-col cols="12" md="10" offset="0" offset-md="1">
              <v-textarea
                v-model="campus.adresseSuaio"
                label="Adresse SUAIO *"
                outlined
                auto-grow
                hide-details="true"
                dense
                @input="resetApiErrors('adresseSuaio')"
                :error-messages="checkApiErrors('adresseSuaio')"
                :rules="adresseRules"
              ></v-textarea>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="5" offset="0" offset-md="1">
              <v-text-field
                v-model="campus.telSuaio"
                label="Téléphone SUAIO *"
                dense
                @input="resetApiErrors('telSuaio')"
                :error-messages="checkApiErrors('telSuaio')"
                :rules="telRules"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="5">
              <v-text-field
                v-model="campus.mailSuaio"
                label="Mail SUAIO *"
                @input="resetApiErrors('mailSuaio')"
                dense
                :error-messages="checkApiErrors('mailSuaio')"
                :rules="mailRules"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="5" offset="0" offset-md="1">
              <v-text-field
                v-model="campus.mailScolarite"
                label="Mail Scolarité *"
                @input="resetApiErrors('mailScolarite')"
                dense
                :error-messages="checkApiErrors('mailScolarite')"
                :rules="mailRules"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-expansion-panels accordion multiple :value="[0]">
                <v-expansion-panel>
                  <v-expansion-panel-header
                    >Référents SUAIO pour ce campus</v-expansion-panel-header
                  >
                  <v-expansion-panel-content>
                    <Referents
                      :referents="campus.referents"
                      typeReferent="referentsSuaio"
                      @addReferent="onAddReferent"
                      @deleteReferent="onDeleteReferent"
                    >
                    </Referents>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels> </v-col
          ></v-row>
          <v-row>
            <v-col cols="12" md="6" offset="0" offset-md="3">
              <div class="text-center">
                <v-btn
                  class="mx-2"
                  :disabled="!valid"
                  color="primary"
                  @click="enregistrer"
                  :loading="loadingCampus"
                >
                  <v-icon left>save</v-icon>Enregistrer
                </v-btn>
                <router-link
                  :to="{
                    name: 'gestion-campus',
                  }"
                  tag="v-btn"
                >
                  <v-icon title="Annuler"></v-icon>
                  Annuler</router-link
                >
              </div>
            </v-col>
          </v-row>
        </v-form>
      </BaseBlock>
    </v-col>
  </v-row>
</template>

<script>
import BaseBlock from "@/components/base/BaseBlock";
import BaseForm from "@/components/base/BaseForm";
import ApiCampusRepository from "@/repositories/ApiCampusRepository";
import Referents from "../components/Referents.vue";
import BaseAlert from "@/components/base/BaseAlert";

export default {
  name: "FormCampus",
  components: { BaseBlock, Referents, BaseAlert },
  extends: BaseForm,
  props: ["idCampus"],

  data() {
    return {
      campus: {
        id: null,
        libelle: "",
        adresseSuaio: "",
        telSuaio: "",
        mailSuaio: "",
        mailScolarite: "",
        referents: [],
      },
      referent: "",
      libelleRules: [
        (v) =>
          (v && v.length >= 2) ||
          "Le libellé doit contenir au minimum 2 caractères",
      ],
      adresseRules: [(v) => !!v || "L'adresse SUAIO est requise"],
      mailRules: [
        (v) => !!v || "Le mail est requis",
        (v) =>
          /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
          "Le mail n'est pas valide",
      ],
      telRules: [
        (v) => !!v || "Le téléphone SUAIO est requis",
        (v) =>
          /(^((0|\+33 ?)[1-9])[0-9]{8}$)|(^[1-9][0-9]{4}$)/.test(v) ||
          "Le téléphone n'est pas valide",
      ],
      loadingCampus: false,
      loadingReferent: false,
    };
  },
  computed: {
    titreCampus() {
      return this.idCampus > 0
        ? "Édition du campus id=" + this.idCampus
        : "Nouveau campus";
    },
  },
  async created() {
    if (this.idCampus > 0) {
      await this.getCampus(this.idCampus);
    }
  },
  methods: {
    async getCampus(id) {
      try {
        const campus = await ApiCampusRepository.getCampus(id);
        this.campus = campus;
      } catch (error) {
        this.populateErrors(error);
      }
    },
    async enregistrer() {
      this.loadingCampus = true;
      try {
        if (this.idCampus > 0) {
          await ApiCampusRepository.updateCampus(this.idCampus, this.campus);
          this.$toast.success("Campus modifié");
        } else {
          await ApiCampusRepository.addCampus(this.campus);
          this.$toast.success("Campus ajouté");
        }
        this.$router.push({ name: "gestion-campus" });
      } catch (error) {
        this.populateErrors(error);
      } finally {
        this.loadingCampus = false;
      }
    },
    onAddReferent(currentReferent) {
      this.campus.referents.push(currentReferent);
    },
    onDeleteReferent(currentReferent) {
      this.campus.referents = this.campus.referents.filter(
        (referent) => referent.uid !== currentReferent.uid
      );
    },
  },
};
</script>
